import * as apiUtils from '../apiCallerProxy';
import { landingPagesApiFactory } from './landingPagesApiFactory';

export * from './hooks';
export default landingPagesApiFactory(apiUtils);
